import ErrorBoundary from "./ErrorBoundary";
import { BasePageProps } from "../types/components";

function QuizPage({ userMode, userAge }: BasePageProps) {
  return (
    <ErrorBoundary>
      <div>
        <h1>Quiz Page</h1>
        <p>Take the quiz to find your feeling.</p>
        {userMode && (
          <div>
            <p>Mode: {userMode}</p>
            {userAge && <p>Age: {userAge}</p>}
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
}

export default QuizPage;
